/**
 * O slug que o cliente manda à API para dizer por qual PORTA está entrando.
 *
 * Na porta base não se manda slug nenhum: é a ausência que a API lê como
 * "base" (`ehPortaBase`), e é só pela base que a mantenedora entra (A044).
 * Mandar o slug da marca configurada na base (hoje `eva-saude`) fazia a API
 * tratar a base como porta de marca e recusar a mantenedora com 401 —
 * regressão de 18/09/2026, quando o login passou a usar `brand.slug` para o
 * domínio personalizado funcionar.
 *
 * Nas outras portas — subdomínio, `/entrar/<slug>` ou domínio personalizado
 * (A050) — o slug é o da marca resolvida.
 */
import { PORTA_BASE } from '@eva/schemas';
import type { BrandDetection } from './detect';
import type { PublicBrand } from './brand.api';

export function slugDaPorta(brand: Pick<PublicBrand, 'slug'>, detection: Pick<BrandDetection, 'identifier' | 'kind' | 'source'>): string | null {
  if (detection.source === 'base' || detection.identifier === PORTA_BASE) return null;
  return brand.slug ?? (detection.kind === 'slug' ? detection.identifier : null);
}
